const cotton_states = [
    {
        "state_id": 15,
        "country_id": 1,
        "state": "Andhra Pradesh",
        "state_latitude": 15.894415,
        "state_longitude": 79.62294416
    },
    {
        "state_id": 3,
        "country_id": 1,
        "state": "Gujarat",
        "state_latitude": 22.41512976,
        "state_longitude": 72.0376327
    },
    {
        "state_id": 5,
        "country_id": 1,
        "state": "Haryana",
        "state_latitude": 29.28968875,
        "state_longitude": 76.05285168
    },
    {
        "state_id": 16,
        "country_id": 1,
        "state": "Karnataka",
        "state_latitude": 15.0218635,
        "state_longitude": 75.53809107
    },
    {
        "state_id": 4,
        "country_id": 1,
        "state": "Madhya Pradesh",
        "state_latitude": 23.969965,
        "state_longitude": 79.39627239
    },
    {
        "state_id": 13,
        "country_id": 1,
        "state": "Maharashtra",
        "state_latitude": 18.81918031,
        "state_longitude": 75.41308259
    },
    {
        "state_id": 6,
        "country_id": 1,
        "state": "Punjab",
        "state_latitude": 31.02831,
        "state_longitude": 75.58561104
    },
    {
        "state_id": 1,
        "country_id": 1,
        "state": "Rajasthan",
        "state_latitude": 26.61925143,
        "state_longitude": 73.8356964
    },
    {
        "state_id": 14,
        "country_id": 1,
        "state": "Telangana",
        "state_latitude": 17.87621,
        "state_longitude": 79.29873787
    }
]
// paddy state  = 9 
const paddy_states = [
    {
        "state_id": 15,
        "country_id": 1,
        "state": "Andhra Pradesh",
        "state_latitude": 15.894415,
        "state_longitude": 79.62294416
    },
    {
        "state_id": 12,
        "country_id": 1,
        "state": "Chhatisgarh",
        "state_latitude": 20.94968058,
        "state_longitude": 81.5091452
    },
    {
        "state_id": 5,
        "country_id": 1,
        "state": "Haryana",
        "state_latitude": 29.28968875,
        "state_longitude": 76.05285168
    },
    {
        "state_id": 16,
        "country_id": 1,
        "state": "Karnataka",
        "state_latitude": 15.0218635,
        "state_longitude": 75.53809107
    },
    {
        "state_id": 6,
        "country_id": 1,
        "state": "Punjab",
        "state_latitude": 31.02831,
        "state_longitude": 75.58561104
    },
    {
        "state_id": 14,
        "country_id": 1,
        "state": "Telangana",
        "state_latitude": 17.87621,
        "state_longitude": 79.29873787
    },
    {
        "state_id": 7,
        "country_id": 1,
        "state": "Uttarakhand",
        "state_latitude": 30.08081871,
        "state_longitude": 79.29790003
    },
    {
        "state_id": 2,
        "country_id": 1,
        "state": "Uttarpradesh",
        "state_latitude": 27.13991378,
        "state_longitude": 80.78202065
    },
    {
        "state_id": 25,
        "country_id": 1,
        "state": "West Bengal",
        "state_latitude": 24.41403,
        "state_longitude": 88.05618227
    }
]
const apple_states = [
    {
        "state_id": 10,
        "country_id": 1,
        "state": "Himachal Pradesh",
        "state_latitude": 31.8180613,
        "state_longitude": 77.33574064
    },
    {
        "state_id": 17,
        "country_id": 1,
        "state": "Jammu And Kashmir",
        "state_latitude": 33.506675,
        "state_longitude": 75.24660411
    }
]

const infest_paddy = [
    'Leaf Folder (Cnaphalocrocis Medinalis )',
    'Yellow Stem Borer (Scirpophaga Incertulas)',
    'Sheath Blight',
    'BPH',
    'Leaf Blast'
]
const infest_apple = [
    'Apple Scab',
    'Woolly Aphids',
    'Apple Bark Borer',
    'Alternaria',
    'Powdery Mildew'
]
const infest_cotton = [
    'Aphids',
    'Bollworm',
    'Fusarium Wilt',
    'Pink Bollworm',
    'Whitefly'
]
const crops = [
    'Apple',
    'Paddy',
    'Cotton'
]
 
function formatDate(date) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options).replace(/,/g, '');
  }
  
  function getWeekDates() {
    const today = new Date();
  
    // Calculate the start of the current week (today)
    const startOfCurrentWeek = new Date(today);
  
    // Calculate the end of the current week (today + 6 days)
    const endOfCurrentWeek = new Date(today);
    endOfCurrentWeek.setDate(today.getDate() + 6);
  
    // Calculate the start of the previous week (today - 7 days)
    const startOfPreviousWeek = new Date(today);
    startOfPreviousWeek.setDate(today.getDate() - 7);
  
    // Calculate the end of the previous week (start of previous week + 6 days)
    const endOfPreviousWeek = new Date(startOfPreviousWeek);
    endOfPreviousWeek.setDate(startOfPreviousWeek.getDate() + 6);
  
    // Calculate the start of the next week (today + 7 days)
    const startOfNextWeek = new Date(today);
    startOfNextWeek.setDate(today.getDate() + 7);
  
    // Calculate the end of the next week (start of next week + 6 days)
    const endOfNextWeek = new Date(startOfNextWeek);
    endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
  
    // Format the dates
    const previousWeek = `${formatDate(startOfPreviousWeek)} to ${formatDate(endOfPreviousWeek)}`;
    const currentWeek = `${formatDate(startOfCurrentWeek)} to ${formatDate(endOfCurrentWeek)}`;
    const nextWeek = `${formatDate(startOfNextWeek)} to ${formatDate(endOfNextWeek)}`;
  
    return {
      previousWeek,
      currentWeek,
      nextWeek
    };
  }
  
  
  
  
export { apple_states, cotton_states, paddy_states, infest_paddy, infest_apple, crops , infest_cotton , getWeekDates }

 